import { render, staticRenderFns } from "./header-index.vue?vue&type=template&id=1ac87361&scoped=true&"
import script from "./header-index.vue?vue&type=script&lang=js&"
export * from "./header-index.vue?vue&type=script&lang=js&"
import style0 from "../assets/less/about.css?vue&type=style&index=0&id=1ac87361&scoped=true&lang=css&"
import style1 from "../assets/less/groundwork.css?vue&type=style&index=1&id=1ac87361&scoped=true&lang=css&"
import style2 from "../assets/less/main.css?vue&type=style&index=2&id=1ac87361&scoped=true&lang=css&"
import style3 from "../assets/less/swiper.min.css?vue&type=style&index=3&id=1ac87361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac87361",
  null
  
)

export default component.exports